/* eslint-disable camelcase */
import { createSelector } from 'reselect';
import translations from 'translations';
import configSelector from './config';

export default createSelector(
  (state) => state.count.payload,
  (_, key) => key,
  configSelector,
  (payload, key, { languageCode }) => {
    let percent = 0;
    const card = payload[key];

    if (!card || !card.data) return { percent, value: null };

    const {
      data: {
        aggregations: { current_period, previous_period },
      },
    } = card;

    const currentDuration = parseFloat((current_period.total_duration.value / 60).toFixed(1));
    const previousDuration = parseFloat((previous_period.total_duration.value / 60).toFixed(1));

    percent = 100;

    if (previousDuration !== 0) {
      percent = Math.round(((currentDuration - previousDuration) / previousDuration) * 100);
    }

    if (previousDuration === 0 && currentDuration === 0) percent = 0;

    return {
      percent,
      value: `${currentDuration} ${translations[languageCode].hours}`,
      previousValue: `${previousDuration} ${translations[languageCode].hours}`,
    };
  },
);
